// extracted by mini-css-extract-plugin
export default {"body__body":"BlogPage_body__body__4vPv+","cards__cards":"BlogPage_cards__cards__ouv+g","typeWriter":"BlogPage_typeWriter__n4jzp","contact":"BlogPage_contact__+AWF-"};